import { fetchAuthSession } from "aws-amplify/auth";

/**
 * Host bridge — the federated module exposed to remotes as `shell/bridge`.
 *
 * This is the ONLY place a remote (indirectly) touches `aws-amplify`, so
 * `aws-amplify` does not need to be a shared/federated singleton. Remotes
 * obtain the access token and a pre-configured http client through here.
 */

// Re-export the existing http factory so remotes get identical interceptors
// (Bearer token, X-Service-Center-ID, TimeZone, date parsing).
export { createHttpInstance as createHttpClient } from "../utils/httpCommon";

export type {
  HostContextValue,
  HostServiceCenter,
  HostUser,
  HostUserGroup,
  MfeMountProps,
} from "./contract";

/** Resolve the current Cognito access token. Amplify refreshes it as needed. */
export const getAccessToken = async (): Promise<string | undefined> => {
  const session = await fetchAuthSession();
  return session.tokens?.accessToken.toString();
};
